let adobeDCView = null;

export function startAdobe({divId, url, fileName}) {
  /* Pass the embed mode option here */
  const viewerConfig = {
    embedMode: 'SIZED_CONTAINER',
    defaultViewMode: 'FIT_WIDTH',
    showAnnotationTools: false,
    showThumbnails: false,
    showBookmarks: false,
    showLeftHandPanel: false,
    showZoomControl: false,
    enableFormFilling: false,
  };

  function onReady() {
    adobeDCView = new window.AdobeDC.View({
      clientId: process.env.REACT_APP_ADOBE_CLIENT_ID,
      sendAutoPDFAnalytics: false,
      divId,
    });

    adobeDCView.previewFile(
      {
        content: {location: {url}},
        metaData: {fileName},
      },
      viewerConfig,
    );
  }

  if (adobeDCView) {
    onReady();
  } else {
    document.addEventListener('adobe_dc_view_sdk.ready', onReady);
  }

  return () => {
    document.removeEventListener('adobe_dc_view_sdk.ready', onReady);
  };
}
